import { resolveMarketplaceOrderFromEmail } from "@nexus/contracts"

export function buildVendorEmailEml(input: {
  from: string | null
  to: readonly string[]
  cc: readonly string[]
  bcc?: readonly string[]
  subject: string
  html: string
  text: string
  sentAt?: string | null
}): string {
  const date = input.sentAt ? new Date(input.sentAt) : new Date()
  const boundary = "nexus-vendor-email"
  const headers = [
    `From: ${resolveMarketplaceOrderFromEmail(input.from)}`,
    `To: ${input.to.join(", ")}`,
    input.cc.length > 0 ? `Cc: ${input.cc.join(", ")}` : "",
    input.bcc && input.bcc.length > 0 ? `Bcc: ${input.bcc.join(", ")}` : "",
    `Subject: ${input.subject.replace(/[\r\n]+/g, " ")}`,
    `Date: ${date.toUTCString()}`,
    "MIME-Version: 1.0",
    `Content-Type: multipart/alternative; boundary="${boundary}"`,
  ].filter(Boolean)

  return [
    ...headers,
    "",
    `--${boundary}`,
    "Content-Type: text/plain; charset=utf-8",
    "",
    input.text,
    `--${boundary}`,
    "Content-Type: text/html; charset=utf-8",
    "",
    input.html,
    `--${boundary}--`,
    "",
  ].join("\r\n")
}
